export default "__VITE_ASSET__BneapVNg__"